import React, { useState, useEffect } from 'react';
import BookmarkDrawer from '../../Notebook/BookmarkDrawer';
import { getQuestionBookmarkStatus } from '../../Notebook/QuestionBookmark/services/notebooksCreate';
import { useCookies } from 'react-cookie';

const BookmarkDrawerGlobal = ({
  questionId,
  packId,
  testId,
  showText = true,
  iconSize = 16,
  className = '',
  handleShowDrawer = () => {},
  handleQuestionNotes = () => {},
  handleQuestionBoomark = () => {},
}) => {
  const [drawerVisible, setDrawerVisible] = useState(true);
  const [bookmarkStatus, setBookmarkStatus] = useState(false);
  const [cookies] = useCookies();

  const fetchBookmarkStatus = async () => {
    if (!questionId) return;
    try {
      const response = await getQuestionBookmarkStatus(questionId);
      if (response.data?.status === 'Not Added' || !response.data?.notebooks?.length) {
        setBookmarkStatus(false);
      } else {
        setBookmarkStatus(true);
      }
    } catch (err) {
      console.error('Error fetching bookmark status:', err);
      setBookmarkStatus(false);
    }
  };

  useEffect(() => {
    if (questionId) {
      fetchBookmarkStatus();
    }
  }, [questionId]);

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  return (
    <>
      {/* <div className={`flex items-center cursor-pointer text-primary ${className}`} onClick={showDrawer}>
        {bookmarkStatus ? (
          <BookmarkCheck size={iconSize} className={showText ? 'mr-1' : ''} />
        ) : (
          <Bookmark size={iconSize} className={showText ? 'mr-1' : ''} />
        )}
        {showText && <span className="hidden md:inline">{bookmarkStatus ? 'Bookmarked' : 'Bookmark'}</span>}
      </div> */}

      <BookmarkDrawer
        visible={drawerVisible}
        onClose={() => {
          setDrawerVisible(false);
          fetchBookmarkStatus();
          handleShowDrawer();
        }}
        questionId={questionId}
        packId={packId}
        testId={testId}
        cookies={cookies}
        handleQuestionNotes={handleQuestionNotes}
        handleQuestionBoomark={handleQuestionBoomark}
      />
    </>
  );
};

export default BookmarkDrawerGlobal;
